import React from 'react';
import {
  renderToStaticMarkup,
} from 'react-dom/server';
import {
  formatTradeValue,
} from '../../numberFormatters';

import {
  colorTripletToCSSString,
} from '../../sharedComponents/webglUtils';
import {
  IProcessedEdge,
  IProcessedNode,
  yDomainWideningFactor,
} from '../../workerStore/network/Utils';
import {
  ActiveStatus,
} from '../../workerStore/network/Utils';
import {
  deselectedNodeBackgroundColor as unexportedNodeBackgroundColorTriplet,
  regularStrokeColor,
  unexportedNodeBackgroundColor as deselectedNodeBackgroundColorTriplet,
} from '../Utils';
import {
  IExportInput,
} from './Utils';

const edgeStroke = colorTripletToCSSString(regularStrokeColor);

const unexportedNodeBackgroundColor = colorTripletToCSSString(unexportedNodeBackgroundColorTriplet);
const deselectedNodeBackgroundColor = colorTripletToCSSString(deselectedNodeBackgroundColorTriplet);

const getFillAndStroke = (active: ActiveStatus, color: string) => {
  let fill: string;
  if (active === ActiveStatus.Active) {
    fill = color;
  } else if (active === ActiveStatus.Deselected) {
    fill = deselectedNodeBackgroundColor;
  } else {
    fill = unexportedNodeBackgroundColor;
  }
  return {
    fill,
    // Give inactive node a border at all times but no border for active node
    // (beacuse of they have colorful fill):
    stroke: (active === ActiveStatus.Active) ? 'none' : 'rgb(235, 235, 245)',
  };
};

const getSVGString = ({nodeList, edgeList, width, height, total}: IExportInput): string  => {

  const nodeElems = nodeList.map((props: IProcessedNode) => {
    const {scaledX, scaledY, id, radius, active, color} = props;
    const {fill, stroke} = getFillAndStroke(active, color);
    return (
      <circle cx={scaledX} cy={scaledY} r={radius}
        fill={fill} stroke={stroke}
        key={`node-${id}`}
      />
    );
  });

  const edgeElems = edgeList.map(({nodes}: IProcessedEdge) => {
    const {scaledX: x1, scaledY: y1, id: firstNodeId} = nodes[0];
    const {scaledX: x2, scaledY: y2, id: secondNodeId} = nodes[1];
    return (
      <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={edgeStroke}
        key={`edge-${firstNodeId}-${secondNodeId}`}
        strokeWidth={0.5}
      />
    );
  });
  const fractionOfHeightOccupiedByActualGraph = 1 / yDomainWideningFactor;
  const fractionOfHeightForTopPadding = (1 - fractionOfHeightOccupiedByActualGraph) / 2;
  const yPositionOfVerticalCenterInsidieTopPadding = height * fractionOfHeightForTopPadding / 2;
  const totalElem = (
    <text textAnchor='middle'
      x={width / 2} y={yPositionOfVerticalCenterInsidieTopPadding}>
        {formatTradeValue(total)}
    </text>
  );
  const svgString = renderToStaticMarkup(
    <svg
      viewBox={`0 0 ${width} ${height}`}
      xmlns='http://www.w3.org/2000/svg'>
      <g>
        {edgeElems}
        {nodeElems}
      </g>
      {totalElem}
    </svg>,
  );
  return svgString;
};

export default getSVGString;
